var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.5018,
    height: 21.5,
    viewBox: "0 0 21.5018 21.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.3121 19.1879C1.3119 18.1877 0.75 16.8312 0.75 15.4167C0.75 14.0022 1.3119 12.6456 2.3121 11.6454C3.31229 10.6452 4.66885 10.0833 6.08333 10.0833C7.49782 10.0833 8.85438 10.6452 9.85457 11.6454C10.8548 12.6456 11.4167 14.0022 11.4167 15.4167C11.4167 16.8312 10.8548 18.1877 9.85457 19.1879C8.85438 20.1881 7.49782 20.75 6.08333 20.75C4.66885 20.75 3.31229 20.1881 2.3121 19.1879Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.41667 15.4167C3.41667 14.7094 3.69762 14.0312 4.19772 13.5311C4.69781 13.031 5.37609 12.75 6.08333 12.75M12.75 7.41669C12.75 8.47779 13.1715 9.49543 13.9218 10.2457C14.6721 10.9961 15.6898 11.4176 16.7509 11.4176C17.812 11.4176 18.8296 10.9961 19.5799 10.2457C20.3303 9.49543 20.7518 8.47779 20.7518 7.41669C20.7518 6.35559 20.3303 5.33794 19.5799 4.58763C18.8296 3.83732 17.812 3.4158 16.7509 3.4158C15.6898 3.4158 14.6721 3.83732 13.9218 4.58763C13.1715 5.33794 12.75 6.35559 12.75 7.41669Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4167 7.41667C15.4167 7.06304 15.5571 6.72391 15.8072 6.47386C16.0572 6.22381 16.3964 6.08333 16.75 6.08333M10.7153 12.7713L13.7696 10.0833M13.0949 5.79L7.32689 3.34022M3.41667 2.75C3.41667 3.28043 3.62738 3.78914 4.00245 4.16421C4.37753 4.53929 4.88623 4.75 5.41667 4.75C5.9471 4.75 6.45581 4.53929 6.83088 4.16421C7.20595 3.78914 7.41667 3.28043 7.41667 2.75C7.41667 2.21957 7.20595 1.71086 6.83088 1.33579C6.45581 0.960714 5.9471 0.75 5.41667 0.75C4.88623 0.75 4.37753 0.960714 4.00245 1.33579C3.62738 1.71086 3.41667 2.21957 3.41667 2.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.a1167e3bd550de0485ea223d4d996448.svg";
export { ForwardRef as ReactComponent };